import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { PortfolioAuthProvider } from "@/hooks/usePortfolioAuth";
import PortfolioGateModal from "@/components/feature/PortfolioGateModal";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <PortfolioAuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
        <PortfolioGateModal />
      </PortfolioAuthProvider>
    </I18nextProvider>
  );
}

export default App;